import React, {useState} from 'react';
import {Comment} from './types'
interface CommentControlsProps{
  submitComment:Function
}
const CommentControls:React.FunctionComponent<CommentControlsProps> = ({ submitComment}:CommentControlsProps) => {
  const [username, setUsername] = useState("")
  const [comment, setComment] = useState("")
  return <>
    <p>name:<input type="text" value={username} onChange={e=>setUsername(e?.target?.value)}/></p>
    <p>comment:<textarea  value={comment} onChange={e=>setComment(e?.target?.value)}/></p>
    <button onClick={
      e=>{
        const newCommentDraft:Comment = {username, comment};
        submitComment(newCommentDraft)
        setUsername('')
        setComment('')
      }}>Submit</button>
  </>
}
export default CommentControls
